'use client';
import { createStore, useStore } from 'zustand';
// import { useStore } from 'zustand';
import { createContext, useContext } from 'react';

export const I18nContext = createContext<I18nStore | null>(null);

export interface I18nProps {
  messages: Record<string, string>;
  loaded: boolean;
  locale: string;
}

export interface I18nState extends I18nProps {
  replace: (messages: Record<string, string>, locale?: string) => void;
  // t: (key: string, values?: Record<string, string>) => string;
}

export type I18nStore = ReturnType<typeof createI18nStore>;

export const createI18nStore = (initProps?: Partial<I18nProps>) => {
  const DEFAULT_PROPS: I18nProps = {
    messages: {},
    locale: '',
    loaded: false,
  };

  return createStore<I18nState>()((set, get) => ({
    ...DEFAULT_PROPS,
    ...initProps,
    replace: (messages, locale) => {
      const loaded = get()?.loaded;

      if (!loaded) {
        set((state) => {
          return { messages, loaded: true, locale: locale || state.locale };
        });
        return;
      }
      console.log('Can only be updated once');
    },
  }));
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('Missing I18nContext.Provider in the tree');
  const messages = useStore(ctx, (s) => s.messages);
  const locale = useStore(ctx, (s) => s.locale);
  const replace = useStore(ctx, (s) => s.replace);

  const t = (key: string, values?: Record<string, string>) => {
    let message = messages[key] || key;
    if (values) {
      Object.keys(values).forEach((k) => {
        message =
          message?.replace(new RegExp(`{${k}}`, 'g'), values[k]) || message;
      });
    }
    return message;
  };

  return {
    messages,
    locale,
    replace,
    t,
  };
};

/**
 * 挂在全局的 i18nStore，用于在任意地方获取 i18nStore，包括非 React 组件中
 */
let i18nStoreGlobal: I18nStore | null = null;

// 初始化时，设置全局的 i18nStore
export const setI18nStore = (store: I18nStore) => {
  i18nStoreGlobal = store;
};

// 获取全局的 i18nStore
export const getI18nStore = (): I18nState => {
  if (i18nStoreGlobal) {
    return i18nStoreGlobal.getState();
  }

  return {
    messages: {},
    loaded: false,
    locale: '',
    replace: (messages, locale) => {},
  };
};
